export const MerchantContactsFields = [
  {
    fieldId: "firstName",
    fieldLabel: "Merchant First Name",
    fieldType: "text",
    placeHolder: "Mike",
    length: 3,
    toolTipId: "toolTipMercFirstName",
    validateType: "alphaSpace",
    required: true,
    toolTipText: "First Name of the Merchant.",
  },
  {
    fieldId: "lastName",
    fieldLabel: "Merchant Last Name",
    fieldType: "text",
    placeHolder: "Smithe",
    length: 3,
    toolTipId: "toolTipMercLastName",
    validateType: "alphaSpace",
    required: true,
    toolTipText: "Last Name of the Merchant.",
  },
  {
    fieldId: "email",
    fieldLabel: "Merchant Email",
    fieldType: "text",
    required: true,
    placeHolder: "mike.smithe@bloomingdales.com",
    validateType: "email",
    length: 3,
    toolTipId: "toolTipMercEmail",
    toolTipText: "Email address of the Merchant.",
  },
  {
    fieldId: "jobRole",
    fieldLabel: "Role",
    fieldType: "select",
    required: true,
    placeHolder: "Select Role..",
    validateType: "req",
    length: 3,
    toolTipId: "toolTipMercRole",
    toolTipText: "Job role of the Merchant.",
    option: [
      {
        optionName: "Buyer",
        optionValue: "Buyer",
      },
      {
        optionName: "Associate Buyer",
        optionValue: "Associate Buyer",
      },
      {
        optionName: "Assistant Buyer",
        optionValue: "Assistant Buyer",
      },
      {
        optionName: "Merchandise Assistant",
        optionValue: "Merchandise Assistant",
      },
      {
        optionName: "Merch Ops",
        optionValue: "Merch Ops",
      },
      {
        optionName: "Other",
        optionValue: "Other",
      },
    ],
  },
];
